// helpers/actionStatus.js
export const actionStatus = [
  { label: "Open", value: "In Progress" },
  { label: "Closed", value: "Closed" },
  { label: "Cancelled", value: "Cancelled" },
];

export const actionCategories = [
  { label: "Risk Management", value: "Risk Management" },
  { label: "HSEQ", value: "HSEQ" },
  { label: "Statutory Approvals", value: "Statutory Approvals" },
  { label: "Project Governance", value: "Project Governance" },
  { label: "Digital Platform", value: "Digital Platform" },
  { label: "Project Execution", value: "Project Execution" },
  { label: "Design", value: "Design" },
  { label: "Project Controls", value: "Project Controls" },
  { label: "Contracts", value: "Contracts" },
  { label: "Procurement", value: "Procurement" },
  { label: "Cost", value: "Cost" },
  { label: "Schedule", value: "Schedule" },
  { label: "Supply Chain & Logistics", value: "Supply Chain & Logistics" },
  { label: "Regulatory & Legal ", value: "Regulatory & Legal " },
  { label: "Weather & Force Majeure", value: "Weather & Force Majeure" },
  { label: "QA/QC", value: "QA/QC" },
  { label: "Facility Operations", value: "Facility Operations" },
  { label: "Central PMO", value: "Central PMO" },
  { label: "Compliance", value: "Compliance" },


];

export const actionDecisionVsOperational = [
  { label: "Decision", value: "Decision" },
  { label: "Operational", value: "Operational" },
  { label: "Internal", value: "Internal" },
];

export const actionSource = [
  { label: "Weekly progress meeting", value: "Weekly progress meeting" },
  { label: "Risk weekly workshop", value: "Risk weekly workshop" },
  { label: "Risk monthly workshop", value: "Risk monthly workshop" },
  { label: "Handover plan meeting", value: "Handover plan meeting" },
  { label: "Risk Register", value: "Risk Register" },
  { label: "Compliance Tracker", value: "Compliance Tracker" },
  { label: "NCR/SO Log", value: "NCR/SO Log" },
];

export const actionResponsible = [
  { label: "Central PMO", value: "Central PMO" },
  { label: "Site PMO", value: "Site PMO" },
  { label: "FourMativ", value: "FourMativ" },
  { label: "GRIP", value: "GRIP" },
  { label: "EPC Contractor", value: "EPC Contractor (GRIL" },
];

export const actionPriority = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "NA", value: "NA" },
];

export const entityList = [
  { label: "Action Tracker", value: "Action Tracker" },
];

export const actionContacts = [
  {
    label: "Archit Agarwal",
    role: "",
    value: "archit@grinfra.com",
    phone: "",
    fullContact: "Archit Agarwal"
  },
  {
    label: "Sudeep Mehrotra",
    role: "CEO",
    value: "leasing.mmlpindore@grinfra.com",
    phone: "",
    fullContact: "Sudeep Mehrotra CEO"
  },
  {
    label: "Bharat Girdhar",
    role: "EA to Archit Agarwal",
    value: "bharat.girdhar@grinfra.com",
    phone: "+91 7017325556",
    fullContact: "Bharat Girdhar\nEA to Archit Agarwal"
  },
  {
    label: "Dipesh Gandhi",
    role: "Chief Development Officer",
    value: "dipesh.g@grinfra.com",
    phone: "",
    fullContact: "Dipesh Gandhi\nChief Development Officer\ndipesh.g@grinfra.com"
  },
  {
    label: "Amol Naik",
    role: "Engineering & Design Lead",
    value: "amol.n@grinfra.com",
    phone: "",
    fullContact: "Amol Naik\nEngineering & Design Lead"
  },
  {
    label: "Shruti",
    role: "Leasing",
    value: "shruti.k@grinfra.com",
    phone: "",
    fullContact: "Shruti\nLeasing"
  },
  {
    label: "Rakesh Pandey",
    role: "Contracts & Procurement",
    value: "Rakesh.p@grinfra.com",
    phone: "",
    fullContact: "Rakesh Pandey\nContracts & Procurement"
  },
  {
    label: "Rajkumar",
    role: "Land & Liasioning",
    value: "raj.singh@grinfra.com",
    phone: "",
    fullContact: "Rajkumar\nLand & Liasioning"
  },
  {
    label: "Vijay Zadage",
    role: "Design - Lead Architect",
    value: "archvijayzagade@gmail.com",
    phone: "",
    fullContact: "Vijay Zadage\nDesign - Lead Architect"
  },
  {
    label: "Manoj Chawan",
    role: "Contracts & Procurement",
    value: "chawanmanoj.k@grinfra.com",
    phone: "",
    fullContact: "Manoj Chawan\nContracts & Procurement"
  },
  {
    label: "Nabeel",
    role: "Finance",
    value: "nabpatel@deloitte.com",
    phone: "",
    fullContact: "Nabeel\nFinance"
  },
  {
    label: "Pushpendra",
    role: "Design - MEP",
    value: "pushpendra.c@grinfra.com",
    phone: "",
    fullContact: "Pushpendra\nDesign - MEP"
  },
  {
    label: "Legin",
    role: "HSE Head",
    value: "legin@abc.com",
    phone: "",
    fullContact: "Legin\nHSE Head"
  },
  // {
  //   label: "TBD",
  //   role: "Quality Head",
  //   value: "",
  //   phone: "",
  //   fullContact: "TBD\nQuality Head"
  // },
  {
    label: "Saurabh Bhale",
    role: "Project Controls",
    value: "saurabh.bhale@grinfra.com",
    phone: "",
    fullContact: "Saurabh Bhale\nProject Controls"
  },
  {
    label: "Saroj Kumar Jha",
    role: "Project Manager",
    value: "saroj.j@grinfra.com",
    phone: "",
    fullContact: "Saroj Kumar Jha\nProject Manager"
  },
  {
    label: "Raktim",
    role: "Project Controls",
    value: "raktim.r@grinfra.com",
    phone: "",
    fullContact: "Raktim\nProject Controls"
  },
  {
    label: "Dharamdas Majhi",
    role: "Project Controls",
    value: "dharmadas.m@grinfra.com",
    phone: "",
    fullContact: "Dharamdas Majhi\nProject Controls"
  },
  {
    label: "Anirudh Verma",
    role: "PMO",
    value: "anirudh.v.verma@pwc.com",
    phone: "",
    fullContact: "Anirudh Verma\nPMO"
  },
  {
    label: "Aruni Sharma",
    role: "PMO",
    value: "aruni.sharma@pwc.com",
    phone: "",
    fullContact: "Aruni Sharma\nPMO"
  },
  {
    label: "Gowtham Ram",
    role: "PMO",
    value: "gowtham.ram.annamalai@pwc.com",
    phone: "",
    fullContact: "Gowtham Ram\nPMO"
  },
  {
    label: "Soma Roy",
    role: "PMO",
    value: "soma.r.roy@pwc.com",
    phone: "",
    fullContact: "Soma Roy\nPMO"
  },
  {
    label: "Yogesh",
    role: "PMO",
    value: "yogesh@grinfra.com",
    phone: "",
    fullContact: "Soma Roy\nPMO"
  },
  {
    label: "Sudhandhu",
    role: "PMO",
    value: "sudhandhu@grinfra.com",
    phone: "",
    fullContact: "Soma Roy\nPMO"
  }
];

export const getPreviousSunday = () => {
  const today = new Date();
  const day = today.getDay();
  const prevSunday = new Date(today);
  prevSunday.setDate(today.getDate() - (day === 0 ? 7 : day));
  return prevSunday;
};
export const getNextSunday = () => {
  const today = new Date();
  const day = today.getDay(); // 0 = Sunday

  const nextSunday = new Date(today);
  const daysToAdd = (7 - day) % 7;  
  nextSunday.setDate(today.getDate() + daysToAdd);

  return nextSunday;

};
export const formatDate = (d) => d.toISOString().split("T")[0];
